import compose from 'recompose/compose';
import { connect } from 'react-redux';
import {
  fetchVehicleSubstatusLog,
  setPageVehicleSubstatusLog,
} from 'store/vehicles/actions';
import VehicleSubstatusLog from './VehicleSubstatusLog';

export default compose(
  connect(
    (state) => ({
      responseDialog: state.vehicles.responseDialog,
      showTitle: false,
      vehicleSubstatusLog: state.vehicles.vehicleSubstatusLog,
    }),
    { fetchVehicleSubstatusLog, setPageVehicleSubstatusLog }
  )
)(VehicleSubstatusLog);
